
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M479.57 415.4L337.46 273.77a192.91 192.91 0 01-59.66 62l140.82 140.37a35.91 35.91 0 0050.55 0l10.4-10.31a35.65 35.65 0 000-50.43z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M333.67 174.78c0-89.08-72.49-161.29-161.86-161.29S10 85.7 10 174.78 82.42 336 171.81 336s161.86-72.15 161.86-161.22zM171.81 298.35C103.33 298.18 48 243 47.79 174.78c.19-68.23 55.53-123.42 124-123.54 68.54.12 123.87 55.31 124 123.54-.12 68.22-55.44 123.4-123.98 123.57z"}})])
          )
        }
      }
    